import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

/**
 * Authentication button component
 * Shows login button when not authenticated, logout button when authenticated
 */
export function AuthButton() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await instance.logoutPopup({
        account: accounts[0],
      });
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (!isAuthenticated || accounts.length === 0) {
    return (
      <button
        type="button"
        onClick={handleLogin}
        className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 transition-colors"
      >
        Sign In
      </button>
    );
  }

  const account = accounts[0];
  const userEmail = account?.username || '';
  const userName = account?.name || userEmail;

  return (
    <div className="flex items-center gap-3">
      <div className="hidden sm:flex flex-col items-end">
        <span className="text-sm font-medium text-zinc-900">{userName}</span>
        <span className="text-xs text-zinc-500">{userEmail}</span>
      </div>
      <button
        type="button"
        onClick={handleLogout}
        className="rounded-lg cursor-pointer border border-zinc-300 bg-white px-4 py-2 text-sm font-medium text-zinc-700 hover:bg-zinc-50 transition-colors"
      >
        Sign Out
      </button>
    </div>
  );
}
